export default "__VITE_ASSET__a9b16402__"